import { render, staticRenderFns } from "./LearningResources.vue?vue&type=template&id=62101f27&"
import script from "./LearningResources.vue?vue&type=script&lang=js&"
export * from "./LearningResources.vue?vue&type=script&lang=js&"
import style0 from "./LearningResources.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports